import { render } from "./CreOperation.vue?vue&type=template&id=86854cf2&scoped=true"
import script from "./CreOperation.vue?vue&type=script&lang=js"
export * from "./CreOperation.vue?vue&type=script&lang=js"

import "./CreOperation.vue?vue&type=style&index=0&id=86854cf2&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86854cf2"]])

export default __exports__